import React, { Component } from 'react';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import TaxCountry from './TaxCountry';
import TaxIdQuestion from './TaxIdQuestion';
import TaxNumber from './TaxNumber';
import PropTypes from '../../../types';
import TaxButtons from './TaxButtons';
import TaxRemoveLink from './TaxRemoveLink';

class TaxObligationFieldList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numObligations:
        this.props.values.taxList && this.props.values.taxList.length > 0
          ? this.props.values.taxList.length
          : 1
    };
    this.onAddAnother = this.onAddAnother.bind(this);
    this.onRemoveOne = this.onRemoveOne.bind(this);
    this.renderObligationList = this.renderObligationList.bind(this);
  }
  componentWillMount() {
    if (
      this.props.values &&
      this.props.values.taxList &&
      this.props.values.taxList &&
      this.props.values.taxList.length > 0
    ) {
      this.setState({ numObligations: this.props.values.taxList.length });
    }
  }
  onAddAnother() {
    this.setState((prevState) => ({
      numObligations:
        prevState.numObligations < this.props.MaxAdditionalCitizenships
          ? prevState.numObligations + 1
          : prevState.numObligations
    }));
  }
  onRemoveOne(index) {
    clearFormFields(this.props.values, index);
    this.setState((prevState) => ({
      numObligations:
        prevState.numObligations > 1 ? prevState.numObligations - 1 : prevState.numObligations
    }));
  }
  renderObligationList(values) {
    const listItems = [];
    for (let i = 0; i < this.state.numObligations; i += 1) {
      listItems.push(
        <div key={i}>
          <TaxCountry itemKey={i} value={values.taxList && values.taxList[i]} />
          <TaxIdQuestion itemKey={i} value={values.taxList && values.taxList[i]} />
          {values.taxList && values.taxList[i] && values.taxList[i].hasTaxNumber === 'Yes' && (
            <ConditionalPanel isVisible>
              <TaxNumber itemKey={i} />
            </ConditionalPanel>
          )}
          {this.state.numObligations > 1 && i !== 0 && (
            <div>
              <TaxRemoveLink
                onRemoveOne={(e) => {
                  e.preventDefault();
                  this.onRemoveOne(i);
                }}
              />
            </div>
          )}
        </div>
      );
    }
    return listItems;
  }
  render() {
    const { values } = this.props;
    return (
      <div>
        {[this.renderObligationList(values)]}
        <TaxButtons
          onAddAnother={() => this.onAddAnother()}
          buttonClickValue={this.state.numObligations}
        />
      </div>
    );
  }
}
const clearFormFields = (values, removeIndex) => {
  if (values.taxList) {
    values.taxList.filter((_v, index) => {
      if (index === removeIndex) {
        delete values.taxList[index];
        values.taxList.splice(index, 1);
        return false;
      }
      return true;
    });
  }
};
TaxObligationFieldList.propTypes = {
  MaxAdditionalCitizenships: PropTypes.number
};
TaxObligationFieldList.defaultProps = {
  MaxAdditionalCitizenships: 5
};
export default TaxObligationFieldList;
